module.exports = __webpack_public_path__ + "img/20250409002258.6d0eae0a.png";